import { Container } from '@mui/material';

export default function FieldAgrilyticsContainer(props) {
  return (
    <Container
      sx={{
        backgroundColor: '#5F5F5F;',
        display: 'flex',
        flexDirection: 'row',
        height: '100%',
        width: '100%',
        '& .MuiBox-root:last-child': { paddingRight: 0 },
      }}
      maxWidth={false}
      disableGutters
      {...props}
    />
  );
}
